import React from 'react';

export type ProgressBarProps = {
  percent?: number;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({ percent = 0 }) => {
  return (
    <div className="progress">
      <div
        className="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        style={{
          width: `${percent}%`,
        }}
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        {percent.toFixed(0)}%
      </div>
    </div>
  );
};
